import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TowerGroupDto } from 'src/app/api/models';
import { GeolocationService } from 'src/shared/services/helpers/geolocation.service';
import { IonItem, IonAvatar, IonList, IonLabel } from "@ionic/angular/standalone";
import { IconComponent } from "../../../../../shared/components/elements/icon/icon.component";
import { NgFor } from '@angular/common';

@Component({
	selector: 'vl-facilities-list',
	templateUrl: './facilities-list.component.html',
	styleUrls: ['./facilities-list.component.scss'],
	imports: [IonLabel, IonList, NgFor, IonAvatar, IonItem, IconComponent],
})
export class FacilitiesListComponent implements OnInit, OnDestroy {
	private notifier: Subject<any> = new Subject<any>();
	@Input() groups: Array<TowerGroupDto>;
	@Output() openModal: EventEmitter<any> = new EventEmitter<any>();

	constructor(private geolocationService: GeolocationService) {
		this.geolocationService.getGroupsObs().pipe(takeUntil(this.notifier)).subscribe((groups) => {
			this.groups = groups;
		});
	}

	ngOnInit() {
	}

	ionViewDidLeave() {
		this.notifier.next('');
		this.notifier.complete();
	}
	
	ngOnDestroy(): void {
		this.notifier.next('');
		this.notifier.complete();
	}

	async open(g) {
		this.openModal.emit(g);
	}
}
